<template>
  <full-screen :title="t('report.real-time-report')" @close="router.back()" show-close>
    <div class="w-full h-auto flex items-center justify-center overflow-auto">
      <div class="max-w-[33rem] w-full h-full">
        <div class="sm:py-4">
          <report-preview v-if="report" :report="report" @print="print()" />
        </div>
      </div>
    </div>
  </full-screen>
</template>

<script setup lang="ts">
import { format, sub } from 'date-fns'
import { storeToRefs } from 'pinia'
import { computed, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import { reportsApi } from '@/api/client'
import FullScreen from '@/components/FullScreen.vue'
import TicketPrinter from '@/integrations/printer/ticketPrinter'
import { useConfigStore } from '@/store/config'

import ReportPreview from './ReportPreview.vue'

const { t } = useI18n()
const router = useRouter()

const configStore = useConfigStore()
const { config } = storeToRefs(configStore)

const report = ref<any>(null)
const endOfDay = computed(() => config.value.workingTime!.end)

const today = computed(() => {
  const endTimeParts = endOfDay.value.split(':')
  const hour = parseInt(endTimeParts[0])
  const minute = parseInt(endTimeParts[1])
  return format(
    sub(new Date(), {
      hours: hour,
      minutes: minute
    }),
    'yyyy-MM-dd'
  )
})

async function refreshReport() {
  report.value = await reportsApi.getZReport({
    startDate: today.value,
    endDate: today.value
  })
}

function print() {
  TicketPrinter.printRealTimeReport()
}

onMounted(() => {
  refreshReport()
})
</script>
